import React, { useState, useEffect, useContext } from 'react';
import Swal from 'sweetalert2';
import Navbar_two from '../Navbar/Navbar2';
import AnimatedPage from '../AnimatedPage/AnimatedPage';
import axios from 'axios';
import { UserDataContext } from '../UserContext/UserContext';

export default function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;
  const { Base_url } = useContext(UserDataContext);

  useEffect(() => {
    axios.get(`${Base_url}/blogs/`)
      .then(response => {
        setBlogs(response.data);
        setFilteredBlogs(response.data);
      })
      .catch(error => {
        console.error('Error fetching blogs:', error);
      });
  }, [Base_url]);

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    setCurrentPage(1); // Reset to page 1
    const filtered = blogs.filter(blog =>
      blog.title.toLowerCase().includes(term.toLowerCase()) ||
      blog.content.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredBlogs(filtered);
  };

  const handleReadMore = (title, content, pdfUrl, author_name, date, imageUrl) => {
    const formattedDate = new Date(date).toLocaleDateString();
    Swal.fire({
      title: `<strong>${title}</strong>`,
      html: `
        ${imageUrl ? `<img src="${imageUrl}" alt="Blog" style="width: 80%; max-height: 150px; object-fit: cover; border-radius: 8px; margin-bottom: 15px;" />` : ''}
        <p><em>By ${author_name || 'Unknown'} on ${formattedDate}</em></p>
   <div style="max-height: 250px; overflow-y: auto; text-align: left; margin-top: 1rem" dir="auto">
        ${content}
      </div>
        ${pdfUrl ? `<a href="${pdfUrl}" target="_blank" class="btn btn-primary mt-3">Download PDF</a>` : ''}
      `,
      showCloseButton: true,
      showConfirmButton: false,
      width: '500px',
      
    });
  };

  // Pagination logic
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <Navbar_two />
      <AnimatedPage>
        <div className="container mt-5">
          <h2 className="text-center fw-bold mb-3">Our Blogs</h2>

          {/* Search Input */}
          <div className="row mb-4">
            <div className="col-md-6 mx-auto">
              <input
                type="text"
                className="form-control"
                placeholder="Search blog title or content..."
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>
          </div>

          {/* Blogs */}
          <div className="row">
            {currentBlogs.map((blog) => (
              <div className="col-md-4 mb-4" key={blog.id}>
                <div className="card h-100 shadow-md">
                  {blog.image && (
                    <img
                      src={blog.image}
                      className="card-img-top"
                      alt="Blog"
                      style={{ height: '200px', objectFit: 'cover' }}
                    />
                  )}
                  <div className="card-body d-flex flex-column" dir="auto">
                    <h5 className="card-title">{blog.title}</h5>
                    <p className="card-text" dir="auto">
                      {blog.content.length > 100
                        ? blog.content.substring(0, 100) + '...'
                        : blog.content}
                    </p>
                    <button
                      className="btn btn-primary mt-auto"
                      onClick={() =>
                        handleReadMore(
                          blog.title,
                          blog.content,
                          blog.pdf,
                          blog.author_name,
                          blog.date_posted,
                          blog.image
                        )
                      }
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <nav>
                <ul className="pagination">
                  {[...Array(totalPages)].map((_, i) => (
                    <li
                      key={i}
                      className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}
                    >
                      <button className="page-link" onClick={() => paginate(i + 1)}>
                        {i + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          )}
        </div>
      </AnimatedPage>
    </div>
  );
}
